import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.analytic.ml_projects"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showModal(false, "create")
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        [
          _c(
            "div",
            { class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.mlops_projects,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.load_date",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  new Date(item.load_date).toLocaleString(
                                    "en-GB"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (data) {
                          return [
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showModal(
                                                        data,
                                                        "view"
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("icon-view"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Ver Proyecto")])]
                            ),
                            data.item.created_user == _vm.getUserEmail
                              ? _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "btn-icon-inca",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.showModal(
                                                            data,
                                                            "edit"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("icon-edit"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Editar Proyecto")])]
                                )
                              : _vm._e(),
                            data.item.created_user == _vm.getUserEmail
                              ? _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "btn-icon-inca",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDelete(
                                                            data.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("icon-delete"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Eliminar Proyecto")])]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                { staticClass: "col-md-3 d-none d-md-block pl-0" },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer pb-0",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "dense" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "mb-2", attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Nombre",
                                      placeholder: "Nombre",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.filters.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "name", $$v)
                                      },
                                      expression: "filters.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "outlined" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("dialog-confirmation-component", {
            ref: "dialogConfirmation",
            attrs: { title: _vm.$t("frases.sure") },
            on: { onConfirm: _vm.onConfirmDelete },
          }),
          _c(
            "DialogsComponent",
            { ref: "dialog", attrs: { title: _vm.modalTitle, width: 800 } },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c(
                    VForm,
                    { ref: "form" },
                    [
                      _c(
                        VRow,
                        { staticClass: "mb-2", attrs: { justify: "center" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Nombre (ID):")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  outlined: !_vm.readonly,
                                  readonly: _vm.readonly,
                                  filled: _vm.readonly,
                                  dense: "",
                                  rules: [
                                    function (v) {
                                      return !!v || "This field is required"
                                    },
                                  ],
                                  "hide-details": "auto",
                                },
                                on: { keydown: _vm.preventSpaces },
                                model: {
                                  value: _vm.record.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.record, "name", $$v)
                                  },
                                  expression: "record.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Descripción :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: !_vm.readonly,
                              readonly: _vm.readonly,
                              filled: _vm.readonly,
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "This field is required"
                                },
                              ],
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.record.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "description", $$v)
                              },
                              expression: "record.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Entorno :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: !_vm.readonly,
                              readonly: _vm.readonly,
                              filled: _vm.readonly,
                              items: ["dev", "prod"],
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "This field is required"
                                },
                              ],
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.record.environment,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "environment", $$v)
                              },
                              expression: "record.environment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Business Abrev. :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: !_vm.readonly,
                              readonly: _vm.readonly,
                              filled: _vm.readonly,
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "This field is required"
                                },
                              ],
                              "hide-details": "auto",
                            },
                            on: { keydown: _vm.preventSpaces },
                            model: {
                              value: _vm.record.business,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "business", $$v)
                              },
                              expression: "record.business",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Versión :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: !_vm.readonly,
                              readonly: _vm.readonly,
                              filled: _vm.readonly,
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "This field is required"
                                },
                              ],
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.record.version,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "version", $$v)
                              },
                              expression: "record.version",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Labels")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_label,
                              "hide-default-footer": "",
                              items: _vm.labels,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem_label()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.label",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.label,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "label", $$v)
                                        },
                                        expression: "data.item.label",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.value",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        rows: "1",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.value,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "value", $$v)
                                        },
                                        expression: "data.item.value",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem_label(
                                                  data
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2" },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Archivos")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c("span", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  "Folder: gs://{bucket}/" +
                                    _vm.record.business +
                                    "-" +
                                    _vm.record.name +
                                    "/data/"
                                )
                              ),
                            ]),
                          ]),
                          _c(VDataTable, {
                            key: _vm.key_archivos,
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_archivos,
                              "hide-default-footer": "",
                              items: _vm.archivos,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !_vm.readonly
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem_archivo()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.folder",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        value: item.folder,
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !_vm.readonly,
                                        readonly: _vm.readonly,
                                        filled: _vm.readonly,
                                      },
                                      model: {
                                        value: item.folder,
                                        callback: function ($$v) {
                                          _vm.$set(item, "folder", $$v)
                                        },
                                        expression: "item.folder",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        value: item.name,
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !_vm.readonly,
                                        readonly: _vm.readonly,
                                        filled: _vm.readonly,
                                      },
                                      model: {
                                        value: item.name,
                                        callback: function ($$v) {
                                          _vm.$set(item, "name", $$v)
                                        },
                                        expression: "item.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.archivo",
                                fn: function (ref) {
                                  var data = ref.data
                                  var index = ref.index
                                  return [
                                    _vm.mode === "view"
                                      ? _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: !_vm.readonly,
                                            readonly: _vm.readonly,
                                            filled: _vm.readonly,
                                            "hide-details": "auto",
                                            "append-icon": "mdi-download ",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              return _vm.downloadFile(
                                                _vm.archivos[index].route,
                                                _vm.archivos[index].name
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.archivos[index].name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.archivos[index],
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "archivos[index].name",
                                          },
                                        })
                                      : _vm._e(),
                                    !_vm.readonly
                                      ? _c(VFileInput, {
                                          attrs: {
                                            rules:
                                              _vm.mode == "edit"
                                                ? []
                                                : [
                                                    function (v) {
                                                      return (
                                                        !!v ||
                                                        _vm.$t(
                                                          "my_tasks.modals.required"
                                                        )
                                                      )
                                                    },
                                                  ],
                                            required:
                                              _vm.mode == "edit" ? false : true,
                                            accept: "*.*",
                                            "prepend-icon": "",
                                            "show-size": "",
                                            outlined: "",
                                            placeholder: "Seleccionar archivo",
                                            dense: "",
                                            "hide-details": "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.getarchivo(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.archivos[index].archivo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.archivos[index],
                                                "archivo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "archivos[index].archivo",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !_vm.readonly
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem_archivo(
                                                  data
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Recipients")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "pl-4",
                              staticStyle: {
                                border: "1px solid #838383",
                                "border-radius": "18px",
                                "padding-top": "10px",
                              },
                            },
                            _vm._l(_vm.recipients, function (recipient, index) {
                              return _c(
                                "li",
                                [
                                  _c(
                                    "span",
                                    { style: { "font-weight": "500" } },
                                    [_vm._v(_vm._s(recipient))]
                                  ),
                                  !_vm.readonly
                                    ? _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            width: "auto",
                                            height: "auto",
                                          },
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deletefunc(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-close")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          !_vm.readonly
                            ? _c(
                                VRow,
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(VTextarea, {
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          rows: "1",
                                        },
                                        model: {
                                          value: _vm.recipient_aux,
                                          callback: function ($$v) {
                                            _vm.recipient_aux = $$v
                                          },
                                          expression: "recipient_aux",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: { outlined: "", dense: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addRow(
                                                _vm.recipient_aux
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-add")]
                                          ),
                                          _vm._v(_vm._s(_vm.$t("common.add"))),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.readonly
                ? _c(
                    "template",
                    { slot: "btnsRight" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "primary",
                          attrs: { color: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _c(VIcon, [_vm._v("icon-send")]),
                          _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }